import { useTheme } from '@/theme/useTheme';
import {
  Box,
  Divider,
  Stack,
  Switch,
  Theme,
  useMediaQuery,
} from '@mui/material';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

// get mui breakpoints key and value in viewport
export const MediaQueryVisual = () => {
  const { theme } = useTheme();

  const { query, push, reload } = useRouter();

  const [currentWindowInnerWidth, setCurrentWindowInnerWidth] = useState(
    typeof window !== 'undefined' ? window?.innerWidth : 0,
  );
  const mx = useMediaQuery((theme: Theme) => theme.breakpoints.up('xs'));
  const sm = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));
  const md = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));
  const lg = useMediaQuery((theme: Theme) => theme.breakpoints.up('lg'));
  const xl = useMediaQuery((theme: Theme) => theme.breakpoints.up('xl'));
  const currentBreakpointMap = [
    { key: 'xs', value: mx, breakpointValue: theme.breakpoints.values.xs },
    { key: 'sm', value: sm, breakpointValue: theme.breakpoints.values.sm },
    { key: 'md', value: md, breakpointValue: theme.breakpoints.values.md },
    { key: 'lg', value: lg, breakpointValue: theme.breakpoints.values.lg },
    { key: 'xl', value: xl, breakpointValue: theme.breakpoints.values.xl },
  ].reverse();

  const currentBreakpointIndex = currentBreakpointMap.findIndex(
    (item) => item.value,
  );
  const currentBreakpoint = currentBreakpointMap[currentBreakpointIndex];
  const nextBreakpoint = currentBreakpointMap[currentBreakpointIndex - 1];

  // update current window inner width
  useEffect(() => {
    const handleResize = () => {
      setCurrentWindowInnerWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  });

  return (
    <Stack
      direction={'row'}
      gap={1}
      sx={{
        position: 'fixed',
        right: 0,
        bottom: 0,
        zIndex: 9999,
        color: 'white',
        fontSize: 12,
        background: 'rgba(0,0,0,0.5)',
      }}
    >
      <Box>
        <Switch
          size="small"
          onChange={(_, checked) => {
            if (checked) {
              query['prod-list'] = 'true';
            } else {
              delete query['prod-list'];
            }
            push({ query }).then(() => {
              reload();
            });
          }}
          checked={!!query['prod-list']}
        />
        Prod game list
      </Box>
      <Divider orientation="vertical" flexItem />
      <Box>Version: {process.env.LATEST_GIT_HASH}</Box>
      <Divider orientation="vertical" flexItem />
      <Box>
        <span>{currentBreakpoint?.breakpointValue || 'xxl'}@</span>
        <span>
          {nextBreakpoint?.breakpointValue || currentWindowInnerWidth}@
        </span>
        <span>{currentBreakpoint?.key || 'max'}@</span>
        <span>{currentWindowInnerWidth}</span>
      </Box>
    </Stack>
  );
};

export default MediaQueryVisual;
